/* eslint-disable jsx-a11y/control-has-associated-label */
import HeartIcon from 'Component/HeartIcon';
import Loader from 'Component/Loader';
import {
    ProductWishlistButton as SourceProductWishlistButton
} from 'SourceComponent/ProductWishlistButton/ProductWishlistButton.component';
/** @namespace Bodypwa/Component/ProductWishlistButton/Component */
export class ProductWishlistButtonComponent extends SourceProductWishlistButton {
    onClick = (e) => {
        const {
            magentoProduct,
            isInWishlist,
            addToWishlist,
            removeFromWishlist
        } = this.props;

        e.preventDefault();

        if (!isInWishlist) {
            return addToWishlist(magentoProduct);
        }

        removeFromWishlist(magentoProduct);

        return addToWishlist(magentoProduct);
    };

    renderLoader() {
        return (
            <Loader isLoading />
        );
    }

    renderContent() {
        const { isInGallery, isLoading } = this.props;
        const contet = isLoading ? this.renderLoader() : this.renderButton();
        return (
            <div block="ProductWishlistButton" mods={ { isInGallery } }>
                { contet }
            </div>
        );
    }

    renderButton() {
        const {
            isInWishlist, isDisabled, mix, hideWishlistButton
        } = this.props;

        if (hideWishlistButton) {
            return null;
        }

        return (
            <button
              block="ProductWishlistButton"
              elem="Button"
              mods={ { isInWishlist, isDisabled } }
              mix={ { block: 'Button', mix } }
              title={ this.getTitle() }
              onClick={ this.onClick }
            >
                <HeartIcon isActive={ isInWishlist } />
            </button>
        );
    }
}

export default ProductWishlistButtonComponent;
